<template>
  <div class="headerNav">
    <header>
      <div class="left">
        <h1>
          <img src="../assets/images/home/logo.png" alt="">
        </h1>
        <p class="address" @click="showCity">
          <img class="address_icon" src="../assets/images/home/adress.png" alt="">
          <span>{{cityName}}</span>
          <img class="down_icon" src="../assets/images/home/xiasanjiaoxing.png" alt="">
        </p>
      </div>
      <div class="right">
        <div class="member" v-if="JSON.stringify(userInfo) === '{}'">
          <div class="login">
            <p class="normal_login">
              <router-link to="/login?type=normal">普通登录</router-link>
            </p>
            <i class="line"></i>
            <p class="merchant_login">
              <router-link to="/login?type=merchant">商家登录</router-link>
            </p>
          </div>
          <div class="register">
            <router-link to="/normalRegister">注册</router-link>
          </div>
        </div>
        <div class="userInfo" v-else>
          <img :src="userBaseInfo.headImg" alt="">
          <p class="username">{{userBaseInfo.mobile}}</p>
          <i class="line"></i>
          <p class="logout" @click="logout">退出登录</p>
        </div>
      </div>
    </header>
    <!--地址-->
    <Area v-if="isArea" @showCity="showCity" @cityinfo="cityinfo"/>

  </div>
</template>

<script>
  import Area from './Area'
  import {mapState} from 'vuex'
  import {reqLogout} from '../api/index'
  import {clearLocalStorage} from '../utils/clearLocalStorage'

  export default {
    name: 'headerNav',
    data () {
      return {
        isArea: false,
        isLogin: false,
        mobile: '',
        sessionId: '',
        cityName: '',
        province: ''
      }
    },
    created () {
      const that = this
      var geolocation = new BMap.Geolocation();
      geolocation.getCurrentPosition(function(r){
        if(this.getStatus() == BMAP_STATUS_SUCCESS){
          var mk = new BMap.Marker(r.point);
          that.cityName = r.address.city
          that.province = r.address.province
          localStorage.setItem('cityName', that.cityName)
          localStorage.setItem('province', that.province)
        }
        else {
          alert('failed'+this.getStatus());
        }
      },{enableHighAccuracy: true})
    },
    methods: {
      showCity () {
        this.isArea = !this.isArea
      },
      // 退出登录
      logout () {
        reqLogout().then(res => {
          clearLocalStorage()
          this.$store.dispatch('clearCurrentState')
          this.$router.replace('/')
        })
      },
      cityinfo (cityinfo) {
        console.log(cityinfo)
        if (cityinfo) {
          this.cityName = cityinfo
        } else {
          this.cityName = '深圳市'
        }

      }
    },
    computed: {
      ...mapState(['userInfo', 'userBaseInfo'])
    },
    components: {
      Area
    }
  }
</script>

<style scoped lang="less" type="text/less">
  .headerNav {
    header {
      display: flex;
      justify-content: space-between;
      height: 80px;
      width: 1200px;
      margin: auto;
      line-height: 80px;

      .left {
        display: flex;

        h1 {
          img {
            margin: 11px 15px 15px 9px;
          }
        }

        .address {
          display: flex;
          cursor: pointer;

          .address_icon {
            width: 14px;
            margin-top: 30px;
            height: 20px;
          }

          span {
            display: block;
            margin: 0 5px 0 10px;
            font-size: 16px;
            color: #333;
            font-family: PingFang-SC-Heavy;
            font-weight: 800;
          }

          .down_icon {
            width: 11px;
            height: 11px;
            margin-top: 36px;
          }
        }
      }

      .right {
        display: flex;

        .member {
          display: flex;

          .login {
            display: flex;

            p {
              color: #333;
              font-size: 14px;
              font-weight: 500;
              font-family: PingFang-SC-Medium;
            }

            i {
              display: block;
              width: 1px;
              height: 12px;
              margin: 34px 17px;
              background: #e1e1e1;
            }
          }

          .register {
            width: 75px;
            height: 30px;
            background: rgba(47, 161, 222, 1);
            border-radius: 15px;
            margin-left: 18px;
            margin-top: 25px;
            line-height: 30px;
            text-align: center;

            a {
              font-size: 14px;
              font-family: PingFang-SC-Heavy;
              font-weight: 800;
              color: #fff;
            }
          }
        }

        .userInfo {
          display: flex;
          align-items: center;

          img {
            width: 40px;
            height: 40px;
            margin-right: 12px;
            background: #eee;
            border-radius: 50%;
          }

          i {
            display: block;
            width: 1px;
            height: 12px;
            margin: 34px 25px;
            background: #e1e1e1;
          }

          .logout {
            cursor: pointer;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/HeaderNav.vue